export default function Section(RecursionHelper) {
  return {
    restrict: 'E',
    template: require('./section.html'),
    scope: {
      level: '<',
      permissions: '<',
      policyDocumentId: '<',
      section: '=',
    },
    controller: 'SectionController',
    controllerAs: 'sectionVM',
    bindToController: true,
    replace: false,
    compile(element) {
      return RecursionHelper.compile(element, recursiveLink);
    },
  };
}

Section.$inject = [
  'RecursionHelper'
];


/**
 * Returns a link function for use in RecursionHelper.compile()
 * @param scope
 * @param iElement
 * @param iAttrs
 * @param controller
 * @param transcludeFn
 * @param physicalConfigController
 */
function recursiveLink(scope, iElement, iAttrs, controller, transcludeFn, physicalConfigController) { // eslint-disable-line no-unused-vars, max-len
  // Define your normal link function here.
  // Alternative: instead of passing a function,
  // you can also pass an object with
  // a 'pre'- and 'post'-link function.
  const children = scope.sectionVM.section.policyDocumentSectionChildren;
  scope.sectionVM.hasChildren = children && children.length > 0;
}
